/* eslint-disable no-restricted-imports */
import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import valueIsNullOrUndef from 'integration/utils/typeAssertions/valueIsNullOrUndef';

export const generateProductViewSeoHref = (
	url?: string,
	clickSource?: CLICK_PRODUCT_VIEW_SOURCE
) => {
	if (valueIsNullOrUndef(url)) {
		return url;
	}

	if (!clickSource) {
		return url;
	}

	return {
		pathname: url,
		query: { clickSource },
	};
};
